import { useState, type PropsWithChildren } from "react";
import { PinScreen } from "./PinScreen";

// La sección de Fotos exige el PIN de nuevo aunque la app ya esté desbloqueada;
// por eso el estado vive aquí, local al componente, y se reinicia cada vez que se entra a la ruta.
export function PhotoPinGuard({ children }: PropsWithChildren) {
  const [unlocked, setUnlocked] = useState(false);

  if (!unlocked) {
    return (
      <PinScreen
        mode="verify"
        title="Fotos privadas"
        subtitle="Introduce tu PIN para continuar"
        onSuccess={() => setUnlocked(true)}
      />
    );
  }

  return <>{children}</>;
}
